import { Button, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { RootState, useAppDispatch, useAppSelector } from "../../store";
import { useNavigate } from "react-router-dom";
import ListDataSkeleton from "../../components/template/skeleton/ListDataSkeleton";
import AddIcon from "@mui/icons-material/Add";
import CompanySearch from "../../components/molecules/company/CompanySearch";
import CompanyTable from "../../components/molecules/company/CompanyTable";
import { useUserAccListQuery } from "../../store/feature/service/UserAccountApiSlice";
import { useCompanyListQuery } from "../../store/feature/service/UserAccountApiSlice copy";
// import { useGetAllOcspListQuery } from '../../store/feature/service/satpasDeviceApiSlice';

const Company = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [params, setParams] = useState<object>({});
  const [defaultValue, setDefaultValue] = useState({});
  const { company } = useAppSelector((state: RootState) => state.role);

  // const data: any = []
  // REGION: DISPATCH OCSP ALL
  // useEffect(()=> {
  //   dispatch(getAllOcspList(params))
  // },[params])

  const { data, isLoading } = useCompanyListQuery(params);

  // REGION: DISPATCH SUCCESS EVENT
  useEffect(() => {
    if (data) {
      console.log("data baru ===> ", data);
    }
  }, [data]);

  useEffect(() => {
    if (company) {
      console.log("company role ===> ", company);
    }
  }, [company]);

  // REGION: RETURN TSX
  return (
    <ListDataSkeleton
      isLoading={isLoading}
      // isLoadingEvent={isLoadingEvent}
      titleWidth={"300px"}
    >
      <Grid container>
        <Grid item xs={10} md={10} lg={10} xl={10}>
          <Typography
            variant="h3"
            fontFamily="Open Sans"
            sx={{ marginY: "20px" }}
          >
            Company
          </Typography>
        </Grid>

        <Grid
          item
          xs={2}
          md={2}
          lg={2}
          xl={2}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          {company?.create && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate("/company/create")}
              sx={{ marginBottom: "18px" }}
            >
              <AddIcon /> Create
            </Button>
          )}
        </Grid>
        <Grid item xs={12} md={12} lg={12} xl={12}>
          <CompanySearch params={params} setParams={setParams} />
          <CompanyTable
            data={data !== undefined && data !== null ? data?.data : []}
            params={params}
            setParams={setParams}
            defaultValue={defaultValue}
            setDefaultValue={setDefaultValue}
          />
        </Grid>
      </Grid>
    </ListDataSkeleton>
  );
};

export default Company;
